// SimpleResumePreview.js - 데스크탑 컨설팅 페이지용 간단한 미리보기

import React from 'react';
import { AllResumeSections } from './ResumeDataSections';
import '../../../styles/desktop/resume.css';

const SimpleResumePreview = ({ resumeData, updatingField, language = 'kr' }) => {
  return (
    <div className="simple-resume-preview resume-container bg-white">
      <div className="resume-content p-6">
        <AllResumeSections 
          resumeData={resumeData} 
          updatingField={updatingField} 
          language={language}
        />
      </div>
    </div>
  );
};

export default SimpleResumePreview;
